module.exports = "https://static.energy5.com/_next/static/images/sliderLedServices-34c14c8692689391559108f941e6db43.webp";